var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import LookupGeneric from "./lookupGeneric";
import ServiceDeliveryLocationService from "../../src/Services/ServiceDeliveryLocation.service";
const ServiceDeliveryLocationLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        defaultIds: props.defaultIds,
        fetchItemsById: (ids) => __awaiter(void 0, void 0, void 0, function* () {
            const res = yield ServiceDeliveryLocationService.search({ ids });
            return res.data;
        }),
        fetchOptions: (search) => __awaiter(void 0, void 0, void 0, function* () {
            const res = yield ServiceDeliveryLocationService.search({
                query: search,
                active: true,
            });
            return res.data;
        }),
        optionRenderer: function optionRenderer(serviceDeliveryLocation) {
            return (_jsxs("span", { children: [serviceDeliveryLocation.location.name, " -", " ", serviceDeliveryLocation.name] }));
        },
    });
};
export default ServiceDeliveryLocationLookup;
